import React, { useState } from 'react'

import './layout.css'

import Sidebar from '../sidebar/Sidebar'
import TopNav from '../topnav/TopNav'

import { Outlet } from 'react-router-dom'

const Layout = ({onClick}) => {

    const [isSandwichOpen,setIsSandwichOpen] = useState(true);
    const toggle = ()=>{
        setIsSandwichOpen((prev)=>!prev)
    }
    // const themeReducer = useSelector(state => state.ThemeReducer)

    // const dispatch = useDispatch()

    // useEffect(() => {
    //     const themeClass = localStorage.getItem('themeMode', 'theme-mode-light')

    //     const colorClass = localStorage.getItem('colorMode', 'theme-mode-light')

    //     dispatch(ThemeAction.setMode(themeClass))

    //     dispatch(ThemeAction.setColor(colorClass))
    // }, [dispatch])

    return (
                <div className={`layout `}>
                    <Sidebar/>
                    <div className="layout__content">
                        <TopNav toggle={toggle} isSandwichOpen={isSandwichOpen} />
                        <div className="layout__content-main">
                            <Outlet />
                        </div>
                    </div>
                </div>
    )
}

export default Layout
